import { useSearchParams } from "react-router-dom";

export const useParamUrl = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getPage = () => {
    const page = searchParams.get("page");
    return page ? parseInt(page) : 1;
  };

  const setUrlPage = (page: any) => {
    searchParams.set("page", page);
    setSearchParams(searchParams);
  };

  return {
    getPage,
    setUrlPage,
  };
};
